import {
  UPDATING_FOLIO_REQUEST, UPDATING_FOLIO_SUCCEDDED, UPDATING_FOLIO_FAILED,
  
  CREATING_FOLIO_REQUEST, CREATING_FOLIO_SUCCEDDED, CREATING_FOLIO_FAILED,
  
  DELETING_FOLIO_REQUEST, DELETING_FOLIO_SUCCEDDED, DELETING_FOLIO_FAILED,
  
  FETCHING_FOLIO_REQUEST, FETCHING_FOLIO_SUCCEDDED, FETCHING_FOLIO_FAILED, 

  FETCHING_COLLECTION_COLLABORATORS_REQUEST, FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED, FETCHING_COLLECTION_COLLABORATORS_FAILED,
  INVALIDATE_COLLECTION_COLLABORATORS,

  UPDATING_COLLECTION_COLLABORATORS_REQUEST, UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED, UPDATING_COLLECTION_COLLABORATORS_FAILED,

  ADD_ASSET_TO_COLLECTION, ADD_ASSET_TO_COLLECTION_SUCCEDDED, ADD_ASSET_TO_COLLECTION_FAILED,

  UPDATING_COLLECTION_LIVE_STATUS_REQUEST, UPDATING_COLLECTION_LIVE_STATUS_SUCCEDDED, UPDATING_COLLECTION_LIVE_STATUS_FAILED,

  FETCHING_FOLIO_SHARED_CONTACTS_REQUEST, FETCHING_FOLIO_SHARED_CONTACTS_SUCCEDDED, FETCHING_FOLIO_SHARED_CONTACTS_FAILED, INVALIDATE_COLLECTION_SHARED_CONTACTS,

  GENERATE_COLLECTION_LINK_REQUEST, GENERATE_COLLECTION_LINK_SUCCEDDED, GENERATE_COLLECTION_LINK_FAILED,
  
  UPDATE_COLLECTION_LINK_REQUEST, UPDATE_COLLECTION_LINK_SUCCEDDED, UPDATE_COLLECTION_LINK_FAILED,
  
  FETCHING_COLLECTION_LINKS_REQUEST, FETCHING_COLLECTION_LINKS_SUCCEDDED, FETCHING_COLLECTION_LINKS_FAILED, SORT_COLLECTION,

  TOGGLE_IS_READ_COLLABORATION_ACCESS, TOGGLE_IS_WIRTE_COLLABORATION_ACCESS, 
  
  CREATING_COLLECTION_LIST_REQUEST, CREATING_COLLECTION_LIST_SUCCEEDED, CREATING_COLLECTION_LIST_FAILED,
  FETCHING_COLLECTION_LISTS_REQUEST, FETCHING_COLLECTION_LISTS_SUCCEEDED, FETCHING_COLLECTION_LISTS_FAILED,
  FETCHING_COLLECTION_LIST_REQUEST, FETCHING_COLLECTION_LIST_SUCCEEDED, FETCHING_COLLECTION_LIST_FAILED,
  DELETING_COLLECTION_LIST_REQUEST, DELETING_COLLECTION_LIST_SUCCEEDED, DELETING_COLLECTION_LIST_FAILED,
  UPDATING_COLLECTION_LIST_REQUEST, UPDATING_COLLECTION_LIST_SUCCEEDED, UPDATING_COLLECTION_LIST_FAILED,
  ADDING_COLLECTION_TO_LIST_REQUEST, ADDING_COLLECTION_TO_LIST_SUCCEEDED, ADDING_COLLECTION_TO_LIST_FAILED,
  REMOVING_COLLECTION_FROM_LIST_REQUEST, REMOVING_COLLECTION_FROM_LIST_SUCCEEDED, REMOVING_COLLECTION_FROM_LIST_FAILED,

  FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_REQUEST,FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_SUCCEEDED,
  FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_FAILED,

  SET_COLLECTION_AS_TEMPLATE_REQUEST, SET_COLLECTION_AS_TEMPLATE_SUCCEEDED, SET_COLLECTION_AS_TEMPLATE_FAILED,
  
  SET_COLLECTION_AS_INTERNAL_REQUEST, SET_COLLECTION_AS_INTERNAL_SUCCEEDED, SET_COLLECTION_AS_INTERNAL_FAILED,

  FETCHING_STAKEHOLDERS, FETCHING_STAKEHOLDERS_SUCCEEDED, FETCHING_STAKEHOLDERS_FAILED, 
  INVALIDATE_FOLIO,
  UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION,
} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';

import { createSelector } from 'reselect'

const apiUrl = process.env.REACT_APP_API_URL;
const COLLECTION_BASE_URL = `${apiUrl}/api/2.0/collections`;
const COLLECTIONS_BASE_URL = `${apiUrl}/api/2.0/collections`;
const COLLECTION_LIST_URL = `${apiUrl}/api/2.0/collection/list`;

const getFolioById = (state, id) => {
  if(state.myCollections.folios){
    return state.myCollections.folios.items.find(function(folio){
      return folio.id == id;
    });
  }
}

export const getFolio = createSelector(
  [getFolioById],
  (folio) =>{
    return folio;
  }
)

//invalidate folio
export function invalidateFolio(id) {
  return {
    type: INVALIDATE_FOLIO,
    payload: id
  }
}

// update asset dimensions bento
export function updateAssetAdditionalDataInCollection(collection, section, assets, editing) {
  return {
    type: UPDATE_ASSET_ADDITIONAL_DATA_IN_COLLECTION,
    payload: {
      collection,
      section,
      assets,
      editing
    }
  }
}

/*
* Create folio action
*/
export function createFolio(folio){
  return function (dispatch) {
    dispatch(creatingFolio(folio));

    return axios({
      method: 'POST',
      url: COLLECTION_BASE_URL,
      data: folio
    })
    .then(response =>
      dispatch(creatingFolioSuccedded(response.data))
    )
    .catch(error =>
      dispatch(creatingFolioFailed(error))
    )
  }
}

function creatingFolio(folio){
  return {
    type: CREATING_FOLIO_REQUEST,
    payload: folio
  }
}

function creatingFolioSuccedded(json){
  return {
    type: CREATING_FOLIO_SUCCEDDED,
    payload: json
  }
}

function creatingFolioFailed(error){
  return {
    type: CREATING_FOLIO_FAILED,
    payload: error
  }
}

export function updateFolio(folio){
  return function (dispatch) {
    dispatch(updatingFolio(folio.id));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: folio.id
    });

    return axios({
      method: 'PUT',
      url: url,
      data: folio
    })
    .then(response =>
      dispatch(updatingFolioSuccedded(folio.id, response.data))
    )
    .catch(error =>
      dispatch(updatingFolioFailed(folio.id, error))
    )
  }
}

function updatingFolio(folioId){
  return {
    type: UPDATING_FOLIO_REQUEST,
    payload: folioId
  }
}

function updatingFolioSuccedded(folioId, json){
  return {
    type: UPDATING_FOLIO_SUCCEDDED,
    payload: {
      id: folioId,
      folio: json
    }
  }
}

function updatingFolioFailed(folioId, error){
  console.log(error);
  return {
    type: UPDATING_FOLIO_FAILED,
    payload: {
      id: folioId,
      error: error
    }
  }
}


export function deleteFolio(folioID){
  return function (dispatch) {
    dispatch(deletingFolio(folioID));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: folioID
    });

    return axios({
      method: 'DELETE',
      url: url
    })
    .then(response =>
      dispatch(deletingFolioSuccedded(folioID))
    )
    .catch(error =>
      dispatch(deletingFolioFailed(folioID, error))
    )
  }
}

function deletingFolio(folioID){
  return {
    type: DELETING_FOLIO_REQUEST,
    payload: folioID
  }
}

function deletingFolioSuccedded(folioID){
  return {
    type: DELETING_FOLIO_SUCCEDDED,
    payload: folioID
  }
}

function deletingFolioFailed(folioID, error){
  console.log(error);
  return {
    type: DELETING_FOLIO_FAILED,
    payload: {
      id: folioID,
      error: error
    }
  }
}

export function fetchFolio(folioID){
  return function (dispatch) {
    dispatch(fetchingFolioRequest(folioID));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: folioID
    });

    const params = {
      includeExternalAssets : true
    }

    return axios({
      method: 'GET',
      url: url,
      params
    })
    .then(response =>
      dispatch(fetchingFolioSuccedded(folioID, response.data))
    )
    .catch(error =>{
      console.log(error);
      return dispatch(fetchingFolioFailed(folioID, error))
    })
  }
}

function fetchingFolioRequest(id){
  return {
    type: FETCHING_FOLIO_REQUEST,
    payload: id
  }
}

function fetchingFolioSuccedded(id, json){
  return {
    type: FETCHING_FOLIO_SUCCEDDED,
    payload: {
      id: id,
      folio: json
    }
  }
}

function fetchingFolioFailed(id, error){
  return {
    type: FETCHING_FOLIO_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}


export function sortCollection(type, order){
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(sortingCollection(type, order));
      resolve();
    });
  }
}

function sortingCollection(type, order) {
  return {
    type: SORT_COLLECTION,
    payload: {
      type: type,
      order: order
    }
  }
}

/**
* Generate Customer Tracking link
*/
export function generateCollectionLink(folio, createLink){
  return function (dispatch) {
    dispatch(generatingCollectionLink(createLink));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${folio.id}/link`
    });
    return axios({
      method: 'POST',
      url: url,
      data: createLink
    })
    .then(response =>
      dispatch(generatingCollectionLinkSuccedded(response.data, createLink))
      
    )
    .catch(error =>
      dispatch(generatingCollectionLinkFailed(error))
    )
  }
}

function generatingCollectionLink(createLink){
  return {
    type: GENERATE_COLLECTION_LINK_REQUEST,
    payload: createLink
  }
}

function generatingCollectionLinkSuccedded(json, createLink){
  return {
    type: GENERATE_COLLECTION_LINK_SUCCEDDED,
    payload: json
  }  
}

function generatingCollectionLinkFailed(error){
  return {
    type: GENERATE_COLLECTION_LINK_FAILED,
    payload: error
  }
}

/**
* Fetch collection CampaignLinks
*/
export function fetchLinksForCollection(id, page){
  return function (dispatch) {
    dispatch(fetchingLinksForCollectionRequest(id));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${id}/links`,
      queryParams: {
        page: page
      }
    });

    return axios({
      method: 'GET',
      url: url
    })
    .then(response =>
      dispatch(fetchingLinksForCollectionSuccedded(id, response.data))
    )
    .catch(error =>
      dispatch(fetchingLinksForCollectionFailed(id, error))
    )
  }
}

function fetchingLinksForCollectionRequest(id){
  return {
    type: FETCHING_COLLECTION_LINKS_REQUEST,
    payload: id
  }
}

function fetchingLinksForCollectionSuccedded(id,json){
  return {
    type: FETCHING_COLLECTION_LINKS_SUCCEDDED,
     payload: {
      id: id,
      links: json
    }
  }
}
//TODO: verify this
// export function removeCollectionSection(id, sectionID) {
//   return function (dispatch) {
//     return new Promise((resolve, reject) => {
//       dispatch(removingCollectionSection(id, sectionID));
//       resolve();
//     });
//   }
// }

// function removingCollectionSection(id, sectionID) {
//   return {
//     type: DELETE_COLLECTION_SECTION,
//     payload: {
//       id: id,
//       section: sectionID
//     }
//   }
// }

function fetchingLinksForCollectionFailed(id,error){
  console.log(error);
  
  return {
    type: FETCHING_COLLECTION_LINKS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
* Fetch collection collaborators
*/
export function fetchCollaboratorsForCollection(id, query, page){
  return function (dispatch) {
    dispatch(fetchingCollaboratorsForCollection(id));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${id}/collaborators`,
      queryParams: {
        query: query,
        page: page
      }
    });

    return axios({
      method: 'GET',
      url: url
    })
    .then(response =>
      dispatch(fetchingCollaboratorsForCollectionSuccedded(id, response.data))
    )
    .catch(error =>
      dispatch(fetchingCollaboratorsForCollectionFailed(id, error))
    )
  }
}

function fetchingCollaboratorsForCollection(id){
  return {
    type: FETCHING_COLLECTION_COLLABORATORS_REQUEST,
    payload: id
  }
}

function fetchingCollaboratorsForCollectionSuccedded(id, json){
  return {
    type: FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED,
    payload: {
      id: id,
      collaborators: json
    }
  }
}

function fetchingCollaboratorsForCollectionFailed(id, error){
  console.log(error);
  return {
    type: FETCHING_COLLECTION_COLLABORATORS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

export function invalidateCollaboratorsForCollection(id){
  return {
    type: INVALIDATE_COLLECTION_COLLABORATORS,
    payload: id
  }
}

export function toggleIsReadCollaboration(id, collaborator) {
  return {
    type: TOGGLE_IS_READ_COLLABORATION_ACCESS,
    payload: {
      id: id,
      collaborator: collaborator
    }
  }
}

export function toggleIsWriteCollaboration(id, collaborator) {
  return {
    type: TOGGLE_IS_WIRTE_COLLABORATION_ACCESS,
    payload: {
      id: id,
      collaborator: collaborator
    }
  }
}

/**
* update collection collaborators
*/
export function updateCollaboratorsForCollection(id, collaborators){
  return function (dispatch) {
    dispatch(updatingCollaboratorsForCollection(id, collaborators));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${id}/collaborators`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: collaborators
    })
    .then(response =>
      dispatch(updatingCollaboratorsForCollectionSuccedded(id, response.data))
    )
    .catch(error =>
      dispatch(updatingCollaboratorsForCollectionFailed(error))
    )
  }
}

function updatingCollaboratorsForCollection(id, request){
  return {
    type: UPDATING_COLLECTION_COLLABORATORS_REQUEST,
    payload: {
      id: id,
      request: request
    }
  }
}

function updatingCollaboratorsForCollectionSuccedded(id, json){
  return {
    type: UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED,
    payload: {
      id: id,
      collaborators: json
    }
  }
}

function updatingCollaboratorsForCollectionFailed(id, error){
  console.log(error);
  return {
    type: UPDATING_COLLECTION_COLLABORATORS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
* Add Asset to Collection
*/
export function addAssetToCollection(id, assets){
  return function (dispatch) {
    dispatch(addingAssetToCollection(id));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${id}/assets`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: assets
    })
    .then(response =>
      dispatch(addingAssetToCollectionSuccedded(id, response.data))
    )
    .catch(error =>
      dispatch(addingAssetToCollectionFailed(id, error))
    )
  }
}

function addingAssetToCollection(id) {
  return {
    type: ADD_ASSET_TO_COLLECTION,
    payload: id
  }
}

function addingAssetToCollectionSuccedded(id, json) {
  return {
    type: ADD_ASSET_TO_COLLECTION_SUCCEDDED,
    payload: {
      id: id,
      collection: json
    }
  }
}

function addingAssetToCollectionFailed(id, error) {
  console.log(error);
  
  return {
    type: ADD_ASSET_TO_COLLECTION_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

//Enable live collection
export function updateCollectionLiveStatus(folio, enable, notifyRecipients, subject, message){
  return function (dispatch) {
    dispatch(updatingCollectionLiveStatus(folio.id));

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${folio.id}/live_status`
    });

    return axios({
      method: 'PUT',
      url: url,
      params : {
        is_live: enable,
        notify_recipients: notifyRecipients,
        subject: subject,
        message: message
      }
    })
    .then(response =>
      dispatch(updatingCollectionLiveStatusSuccedded(folio.id, response.data))
    )
    .catch(error =>
      dispatch(updatingCollectionLiveStatusFailed(folio.id, error))
    )
  }
}

function updatingCollectionLiveStatus(folioId){
  return {
    type: UPDATING_COLLECTION_LIVE_STATUS_REQUEST,
    payload: folioId
  }
}

function updatingCollectionLiveStatusSuccedded(folioId, json){
  return {
    type: UPDATING_COLLECTION_LIVE_STATUS_SUCCEDDED,
    payload: {
      id: folioId,
      folio: json
    }
  }
}

function updatingCollectionLiveStatusFailed(folioId, error){
  return {
    type: UPDATING_COLLECTION_LIVE_STATUS_FAILED,
    payload: {
      id: folioId,
      error: error
    }
  }
}


//Fetch Shared Contacts
export function fetchFolioSharedContacts(folioID, page){
  return function (dispatch) {
    dispatch(fetchingFolioSharedContactRequest(folioID));

     var param = {
      page: page
    }


    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `${folioID}/recipients`
    });

    return axios({
      method: 'GET',
      url: url,
      params : param
    })
    .then(response =>
      dispatch(fetchingFolioSharedContactSuccedded(folioID,response.data))
    )
    .catch(error =>{
      console.log(error);
      return dispatch(fetchingFolioSharedContactFailed(folioID,error))
    })
  }
}

function fetchingFolioSharedContactRequest(id){
  return {
    type: FETCHING_FOLIO_SHARED_CONTACTS_REQUEST,
    payload: id
  }
}

function fetchingFolioSharedContactSuccedded(id,json){
  return {
    type: FETCHING_FOLIO_SHARED_CONTACTS_SUCCEDDED,
     payload: {
      id: id,
      sharedContacts: json
    }
  }
}

function fetchingFolioSharedContactFailed(id,error){
  return {
    type: FETCHING_FOLIO_SHARED_CONTACTS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

export function invalidateSharedContactForCollection(id){
  return {
    type: INVALIDATE_COLLECTION_SHARED_CONTACTS,
    payload: id
  }
}

/* Delete Collection Utm Camapign Link*/

// export function deleteCollectionUtmCamapignLink(folioID, campaignLinkId){
//   return function (dispatch) {
//     dispatch(deletingCollectionUtmCamapignLink(folioID, campaignLinkId));

//     let url = buildUrl(COLLECTION_BASE_URL, {
//       path: `${folioID}/utm_campaign_links/${campaignLinkId}`
//     });

//     return axios({
//       method: 'DELETE',
//       url: url
//     })
//     .then(response =>
//       dispatch(deletingCollectionUtmCamapignLinkSuccedded(folioID, campaignLinkId))
//     )
//     .catch(error =>
//       dispatch(deletingCollectionUtmCamapignLinkFailed(folioID,campaignLinkId, error))
//     )
//   }
// }

// function deletingCollectionUtmCamapignLink(folioID,campaignLinkId){
//   return {
//     type: DELETING_COLLECTION_UTM_CAMPAIGN_LINKS_REQUEST,
//     payload: {
//       folioId : folioID,
//       campaignLinkId : campaignLinkId
//     }
//   }
// }

// function deletingCollectionUtmCamapignLinkSuccedded(folioID, campaignLinkId){
//   return {
//     type: DELETING_COLLECTION_UTM_CAMPAIGN_LINKS_SUCCEDDED,
//     payload: {
//       folioId : folioID,
//       campaignLinkId : campaignLinkId
//     }
//   }
// }

// function deletingCollectionUtmCamapignLinkFailed(folioID, campaignLinkId, error){
//   console.log(error);
//   return {
//     type: DELETING_COLLECTION_UTM_CAMPAIGN_LINKS_FAILED,
//     payload: {
//       folioId : folioID,
//       campaignLinkId : campaignLinkId,
//       error: error
//     }
//   }
// }


/**
* Update Customer Tracking link
*/
export function updateCollectionLink(id,createLink){
  return function (dispatch) {
    dispatch(updatingCollectionLink());

    let url = buildUrl(COLLECTION_BASE_URL, {
      path: `link/${id}`
    });
    return axios({
      method: 'PUT',
      url: url,
      data: createLink
    })
    .then(response =>
      dispatch(updatingCollectionLinkSuccedded(response.data))
    )
    .catch(error =>
      dispatch(updatingCollectionLinkFailed(error))
    )
  }
}

function updatingCollectionLink(){
  return {
    type: UPDATE_COLLECTION_LINK_REQUEST,
    payload: {}
  }
}

function updatingCollectionLinkSuccedded(json){
  return {
    type: UPDATE_COLLECTION_LINK_SUCCEDDED,
    payload: json
  }  
}

function updatingCollectionLinkFailed(error){
  return {
    type: UPDATE_COLLECTION_LINK_FAILED,
    payload: error
  }
}

/*
* Create collections list action
*/

export function createCollectionList(collectionList) {
  return function (dispatch) {
    dispatch(creatingCollectionList());

    return axios({
      method: 'POST',
      url: COLLECTION_LIST_URL,
      data: collectionList
    })
      .then(response => {
        return dispatch(creatingCollectionListSucceeded(response.data))
      })
      .catch(error => {
        return dispatch(creatingCollectionListFailed(error))
      })
  }
}

function creatingCollectionList() {
  return {
    type: CREATING_COLLECTION_LIST_REQUEST,
    payload: {}
  }
}

function creatingCollectionListSucceeded(string) {
  return {
    type: CREATING_COLLECTION_LIST_SUCCEEDED,
    payload: string
  }
}

function creatingCollectionListFailed(error) {
  return {
    type: CREATING_COLLECTION_LIST_FAILED,
    payload: error
  }
}

/*
* Fetching collection lists
*/
export function fetchCollectionLists() {
  return function (dispatch) {
    dispatch(fetchingCollectionLists());

    return axios({
      method: 'GET',
      url: COLLECTION_LIST_URL
    })
      .then(response => {
        return dispatch(fetchingCollectionListsSucceeded(response.data))
      })
      .catch(error => {
        return dispatch(fetchingCollectionListsFailed(error))
      })
  }
}

function fetchingCollectionLists() {
  return {
    type: FETCHING_COLLECTION_LISTS_REQUEST,
    payload: {}
  }
}

function fetchingCollectionListsSucceeded(string) {
  return {
    type: FETCHING_COLLECTION_LISTS_SUCCEEDED,
    payload: string
  }
}

function fetchingCollectionListsFailed(error) {
  return {
    type: FETCHING_COLLECTION_LISTS_FAILED,
    payload: error
  }
}

/*
* Fetching a collection list
*/
export function fetchCollectionList(collectionListID) {
  return function (dispatch) {
    dispatch(fetchingCollectionList(collectionListID));

    let url = buildUrl(COLLECTION_LIST_URL, {
      path: collectionListID
    });

    return axios({
      method: 'GET',
      url: url
    })
      .then(response => {
        return dispatch(fetchingCollectionListSucceeded(collectionListID, response.data))
      })
      .catch(error => {
        return dispatch(fetchingCollectionListFailed(collectionListID, error))
      })
  }
}

function fetchingCollectionList(collectionListID) {
  return {
    type: FETCHING_COLLECTION_LIST_REQUEST,
    payload: collectionListID
  }
}

function fetchingCollectionListSucceeded(collectionListID, json) {
  return {
    type: FETCHING_COLLECTION_LIST_SUCCEEDED,
    payload: {
      id: collectionListID,
      folio: json
    }
  }
}

function fetchingCollectionListFailed(error) {
  return {
    type: FETCHING_COLLECTION_LIST_FAILED,
    payload: error
  }
}

/*
* Deleting a collection list
*/
export function deleteCollectionList(collectionListID, deleteCollections) {
  return function (dispatch) {
    dispatch(deletingCollectionList(collectionListID));

    let url = buildUrl(COLLECTION_LIST_URL, {
      path: collectionListID
    });

    return axios({
      method: 'DELETE',
      url: url,
      params: {
        deleteCollections: deleteCollections
      }
    })
      .then(response =>
        dispatch(deletingCollectionListSuccedded(collectionListID))
      )
      .catch(error =>
        dispatch(deletingCollectionListFailed(collectionListID, error))
      )
  }
}

function deletingCollectionList(collectionListID) {
  return {
    type: DELETING_COLLECTION_LIST_REQUEST,
    payload: collectionListID
  }
}

function deletingCollectionListSuccedded(collectionListID) {
  return {
    type: DELETING_COLLECTION_LIST_SUCCEEDED,
    payload: collectionListID
  }
}

function deletingCollectionListFailed(folioID, error) {
  console.log(error);
  return {
    type: DELETING_COLLECTION_LIST_FAILED,
    payload: {
      id: folioID,
      error: error
    }
  }
}

/**
 * Updating Collection List
 */
export function updateCollectionList(id, collectionList) {
  return function (dispatch) {
    dispatch(updatingCollectionList(id));

    let url = buildUrl(COLLECTION_LIST_URL, {
      path: `${id}`
    });

    return axios({
      method: 'PUT',
      url: url,
      data: collectionList
    })
      .then(response => {
        return dispatch(updatingCollectionListSuccedded(id, response.data))
      })
      .catch(error => {
        return dispatch(updatingCollectionListFailed(id, error))
      })
  }
}

function updatingCollectionList(id) {
  return {
    type: UPDATING_COLLECTION_LIST_REQUEST,
    payload: id
  }
}

function updatingCollectionListSuccedded(id, json) {
  return {
    type: UPDATING_COLLECTION_LIST_SUCCEEDED,
    payload: {
      id: id,
      collectionList: json
    }
  }
}

function updatingCollectionListFailed(id, error) {
  return {
    type: UPDATING_COLLECTION_LIST_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Add collection to list
 */
export function addCollectionToList(source, target, collection) {
  return function (dispatch) {
    dispatch(addingCollectionToList(source, target, collection));

    let url = buildUrl(COLLECTION_LIST_URL, {
      path: `${target.id}/collections`
    });

    return axios({
      method: 'POST',
      url: url,
      data: [collection.id]
    })
    .then(response => {
      return dispatch(addingCollectionToListSuccedded(source, target, collection))
    })
    .catch(error => {
      console.log(error)
      return dispatch(addingCollectionToListFailed(source, target, collection, error))
    })
  }
}

function addingCollectionToList(source, target, collection) {
  return {
    type: ADDING_COLLECTION_TO_LIST_REQUEST,
    payload: {
      source: source,
      target: target.id,
      collection: collection
    }
  }
}

function addingCollectionToListSuccedded(source, target, collection) {
  return {
    type: ADDING_COLLECTION_TO_LIST_SUCCEEDED,
    payload: {
      source: source,
      target: target.id,
      collection: collection.id
    }
  }
}

function addingCollectionToListFailed(source, target, collection, error) {
  return {
    type: ADDING_COLLECTION_TO_LIST_FAILED,
    payload: {
      source: source,
      target: target.id,
      error: error
    }
  }
}

/**
 * Remove collection from list
 */
export function removeCollectionFromList(list, collection) {
  return function (dispatch) {
    dispatch(removingCollectionFromList(list, collection));

    let url = buildUrl(COLLECTION_LIST_URL, {
      path: `${list}/collections`
    });

    return axios({
      method: 'DELETE',
      url: url,
      data: [collection.id]
    })
    .then(response => {
      return dispatch(removingCollectionFromListSuccedded(list, collection))
    })
    .catch(error => {
      console.log(error)
      return dispatch(removingCollectionFromListFailed(list, collection, error))
    })
  }
}

function removingCollectionFromList(list, collection) {
  return {
    type: REMOVING_COLLECTION_FROM_LIST_REQUEST,
    payload: {
      list: list,
      collection: collection
    }
  }
}

function removingCollectionFromListSuccedded(list, collection) {
  return {
    type: REMOVING_COLLECTION_FROM_LIST_SUCCEEDED,
    payload: {
      list: list,
      collection: collection.id
    }
  }
}

function removingCollectionFromListFailed(list, collection, error) {
  return {
    type: REMOVING_COLLECTION_FROM_LIST_FAILED,
    payload: {
      list: list,
      error: error
    }
  }
}

/**
 * Fetch collaborated users from list
 */
export function fetchCollaboratedUsers(id) {
  return function (dispatch) {
    dispatch(fetchingCollaboratedUsers(id));
    
    let url = buildUrl(COLLECTIONS_BASE_URL, {
      path: `${id}/collaborators/filtered`
    });

    return axios({
      method: 'GET',
      url: url,
    })
    .then(response => {
      return dispatch(fetchingCollaboratedUsersSuccedded(id,response.data))
    })
    .catch(error => {
      console.log(error)
      return dispatch(fetchingCollaboratedUsersFailed(id))
    })
  }
}
function fetchingCollaboratedUsers(id){
  return {
    type: FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_REQUEST,
    payload: id
  }
}

function fetchingCollaboratedUsersSuccedded(id, json){
  return {
    type: FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_SUCCEEDED,
    payload: {
      id: id,
      collaborators: json
    }
  }
}

function fetchingCollaboratedUsersFailed(id, error){
  console.log(error);
  return {
    type: FETCHING_COLLABORATED_USERS_AND_USER_GROUPS_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Set Collection As Template
 */
export function setCollectionAsTemplate(id, enable) {
  return function (dispatch) {
    dispatch(settingCollectionAsTemplate(id));
    
    let url = buildUrl(COLLECTIONS_BASE_URL, {
      path: `${id}/template`
    });

    return axios({
      method: 'PUT',
      url: url,
      params : {
        collection_template: enable,
      }
    })
    .then(response => {
      return dispatch(setCollectionAsTemplateSucceeded(id,response.data))
    })
    .catch(error => {
      console.log(error)
      return dispatch(setCollectionAsTemplateFailed(id))
    })
  }
}
function settingCollectionAsTemplate(id){
  return {
    type: SET_COLLECTION_AS_TEMPLATE_REQUEST,
    payload: id
  }
}

function setCollectionAsTemplateSucceeded(id, json){
  return {
    type: SET_COLLECTION_AS_TEMPLATE_SUCCEEDED,
    payload: {
      id: id,
      folio: json
    }
  }
}

function setCollectionAsTemplateFailed(id, error){
  console.log(error);
  return {
    type: SET_COLLECTION_AS_TEMPLATE_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Set Collection As Internal
 */
export function setCollectionAsInternal(id, internal) {
  return function (dispatch) {
    dispatch(settingCollectionAsInternal(id));

    let url = buildUrl(COLLECTIONS_BASE_URL, {
      path: `${id}/internal`
    });

    return axios({
      method: 'PUT',
      url: url,
      params: {
        internal: internal,
      }
    })
      .then(response => {
        return dispatch(setCollectionAsInternalSucceeded(id, response.data))
      })
      .catch(error => {
        console.log(error)
        return dispatch(setCollectionAsInternalFailed(id))
      })
  }
}
function settingCollectionAsInternal(id) {
  return {
    type: SET_COLLECTION_AS_INTERNAL_REQUEST,
    payload: id
  }
}

function setCollectionAsInternalSucceeded(id, json) {
  return {
    type: SET_COLLECTION_AS_INTERNAL_SUCCEEDED,
    payload: {
      id: id,
      folio: json
    }
  }
}

function setCollectionAsInternalFailed(id, error) {
  return {
    type: SET_COLLECTION_AS_INTERNAL_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}
